/**
 * Get folder icon based on hierarchy level and max depth
 * @param {Object} item - Folder item with hierarchyLevel and maxDepth
 * @returns {string} Icon name
 */
export function getFolderIcon(item) {
  if (!item || !item.hierarchyLevel || !item.maxDepth) {
    return "folder";
  }

  // For 3-level structure: second level is class-group
  if (
    (item.maxDepth === 3 && item.hierarchyLevel === 2) ||
    (item.maxDepth === 2 && item.hierarchyLevel === 1)
  ) {
    return "class-group";
  }

  // Last level is always assignment-document
  if (item.hierarchyLevel === item.maxDepth) {
    return "assignment-document";
  }

  // First level is always folder
  return "folder";
}
